/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc
 */
import * as References from './WorkspacesRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery, registerMutation } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#create
 */
export const CREATE_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_create';
export const CREATE_MUTATION: RegisteredQuery<
  'result',
  References.CreateRequestType,
  References.CreateResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CREATE_MUTATION_FIELD_NAME,
  args: ['name'],
  fetcher(
    request: References.CreateRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CreateResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.createRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#start
 */
export const START_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_start';
export const START_MUTATION: RegisteredQuery<
  'result',
  References.StartRequestType,
  References.StartResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: START_MUTATION_FIELD_NAME,
  args: ['initialPrompt', 'name'],
  fetcher(
    request: References.StartRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.StartResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.startRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#fork
 */
export const FORK_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_fork';
export const FORK_MUTATION: RegisteredQuery<
  'result',
  References.ForkRequestType,
  References.ForkResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: FORK_MUTATION_FIELD_NAME,
  args: ['parentVersionId', 'prompt'],
  fetcher(
    request: References.ForkRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ForkResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.forkRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#restore
 */
export const RESTORE_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_restore';
export const RESTORE_MUTATION: RegisteredQuery<
  'result',
  References.RestoreRequestType,
  References.RestoreResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: RESTORE_MUTATION_FIELD_NAME,
  args: ['versionId'],
  fetcher(
    request: References.RestoreRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.RestoreResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.restoreRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#clone
 */
export const CLONE_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_clone';
export const CLONE_MUTATION: RegisteredQuery<
  'result',
  References.CloneRequestType,
  References.CloneResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: CLONE_MUTATION_FIELD_NAME,
  args: ['workspaceId', 'name'],
  fetcher(
    request: References.CloneRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.CloneResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.cloneRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getById
 */
export const GET_BY_ID_QUERY_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getById';
export const GET_BY_ID_QUERY: RegisteredQuery<
  'result',
  References.GetByIdRequestType,
  References.GetByIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_ID_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(
    request: References.GetByIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getByIdRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getComponents
 */
export const GET_COMPONENTS_QUERY_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getComponents';
export const GET_COMPONENTS_QUERY: RegisteredQuery<
  'result',
  References.GetComponentsRequestType,
  References.GetComponentsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_COMPONENTS_QUERY_FIELD_NAME,
  args: ['versionId'],
  fetcher(
    request: References.GetComponentsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetComponentsResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getComponentsRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getByProjectName
 */
export const GET_BY_PROJECT_NAME_QUERY_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getByProjectName';
export const GET_BY_PROJECT_NAME_QUERY: RegisteredQuery<
  'result',
  References.GetByProjectNameRequestType,
  References.GetByProjectNameResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_PROJECT_NAME_QUERY_FIELD_NAME,
  args: ['projectName'],
  fetcher(
    request: References.GetByProjectNameRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByProjectNameResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getByProjectNameRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getByConversation
 */
export const GET_BY_CONVERSATION_QUERY_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getByConversation';
export const GET_BY_CONVERSATION_QUERY: RegisteredQuery<
  'result',
  References.GetByConversationRequestType,
  References.GetByConversationResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_BY_CONVERSATION_QUERY_FIELD_NAME,
  args: ['conversationId'],
  fetcher(
    request: References.GetByConversationRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetByConversationResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getByConversationRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#updateInfo
 */
export const UPDATE_INFO_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_updateInfo';
export const UPDATE_INFO_MUTATION: RegisteredQuery<
  'result',
  References.UpdateInfoRequestType,
  References.UpdateInfoResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UPDATE_INFO_MUTATION_FIELD_NAME,
  args: [
    'id',
    'name',
    'appNameUserOverride',
    'appDescriptionUserOverride',
    'appNameOverridden',
    'appDescriptionOverridden',
    'iconBase64',
  ],
  fetcher(
    request: References.UpdateInfoRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UpdateInfoResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.updateInfoRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#delete
 */
export const DELETE_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_delete';
export const DELETE_MUTATION: RegisteredQuery<
  'result',
  References.DeleteRequestType,
  References.DeleteResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: DELETE_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(
    request: References.DeleteRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.DeleteResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.deleteRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#publish
 */
export const PUBLISH_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_publish';
export const PUBLISH_MUTATION: RegisteredQuery<
  'result',
  References.PublishRequestType,
  References.PublishResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: PUBLISH_MUTATION_FIELD_NAME,
  args: ['versionId'],
  fetcher(
    request: References.PublishRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.PublishResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.publishRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#unpublish
 */
export const UNPUBLISH_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_unpublish';
export const UNPUBLISH_MUTATION: RegisteredQuery<
  'result',
  References.UnpublishRequestType,
  References.UnpublishResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: UNPUBLISH_MUTATION_FIELD_NAME,
  args: ['id'],
  fetcher(
    request: References.UnpublishRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.UnpublishResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.unpublishRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getPageViaId
 */
export const GET_PAGE_VIA_ID_QUERY_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getPageViaId';
export const GET_PAGE_VIA_ID_QUERY: RegisteredQuery<
  'result',
  References.GetPageViaIdRequestType,
  References.GetPageViaIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PAGE_VIA_ID_QUERY_FIELD_NAME,
  args: ['namePart', 'sort', 'offset', 'pageLength'],
  fetcher(
    request: References.GetPageViaIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPageViaIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getPageViaIdRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getPageViaOffset
 */
export const GET_PAGE_VIA_OFFSET_QUERY_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getPageViaOffset';
export const GET_PAGE_VIA_OFFSET_QUERY: RegisteredQuery<
  'result',
  References.GetPageViaOffsetRequestType,
  References.GetPageViaOffsetResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PAGE_VIA_OFFSET_QUERY_FIELD_NAME,
  args: ['namePart', 'sort', 'offset', 'pageLength'],
  fetcher(
    request: References.GetPageViaOffsetRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetPageViaOffsetResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getPageViaOffsetRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#toggleFavorite
 */
export const TOGGLE_FAVORITE_MUTATION_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_toggleFavorite';
export const TOGGLE_FAVORITE_MUTATION: RegisteredQuery<
  'result',
  References.ToggleFavoriteRequestType,
  References.ToggleFavoriteResponseType
> = /* #__PURE__ */ registerMutation({
  fieldName: TOGGLE_FAVORITE_MUTATION_FIELD_NAME,
  args: ['workspaceId', 'namePart', 'offset', 'pageLength'],
  fetcher(
    request: References.ToggleFavoriteRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.ToggleFavoriteResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.toggleFavoriteRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.dpg.devex.agents.rpc.WorkspacesRpc#getSuggestedPrompts
 */
export const GET_SUGGESTED_PROMPTS_QUERY_FIELD_NAME =
  'com_hubspot_dpg_devex_agents_rpc_WorkspacesRpc_getSuggestedPrompts';
export const GET_SUGGESTED_PROMPTS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetSuggestedPromptsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SUGGESTED_PROMPTS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSuggestedPromptsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSuggestedPromptsRpc,
      { timeout: ctx.timeout, request: {} }
    );
  },
});
